import PropTypes from 'prop-types';

const CustomExpandRow = ({ width, title, text }) => {
  return (
    <div className="vehicle-management-expand-div">
      <span className="new-car-demands-expand-head" style={{ width: width }}>
        {title}
      </span>
      <span className="vehicle-management-expand-text">{text}</span>
    </div>
  );
};

CustomExpandRow.propTypes = {
  width: PropTypes.number,
  title: PropTypes.string,
  text: PropTypes.string,
};

export default CustomExpandRow;
